import { compose, propEq, find } from 'ramda'

export const getUpgradePopupConcurrentMessage = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_CONCURRENT_MSG'))
)
